export const partners = [
  {
      "name": {
          "en": "Clients",
          "es": "Clientes",
          "pt": "Clientes"
      },
      "logo": [
          "clients/liberty-mutual.png",
          "clients/bmw.png",
          "clients/dekra.png",
          "clients/fixico.png",
          "clients/holiday-cars.png",
          "clients/ntt-data-services.png",
          "clients/kotak.jpg",
          "clients/age.png"
      ]
  },
  {
      "name": {
          "en": "Investors",
          "es": "Inversores",
          "pt": "Investidores"
      },
      "logo": [
          "techstars.png",
          "barclays.png",
          "titancapital.png",
          "bettercapital.svg"
      ]
  },
  {
      "name": {
          "en": "Partners",
          "es": "Socios",
          "pt": "Parceiros"
      },
      "logo": [
          "mitchell.png",
          "gt-motive.png",
          "plug-and-play.jpg",
          "mindtree.jpg",
          "aws.png",
          "microsoft.png"
      ]
  }
];

export const awards = [
  {
    name: 'Winner NTT Data Global innovation contest, Tokyo, 2021',
    img: 'nttopen.png',
    url: 'https://in.nttdata.com/en/news/press-release/2021/february/result-of-open-innovation-contest-11',
  },

  {
    name: 'Zurich Innovation Championship: Inspektlabs e Minalea vencem fase nacional, 2023',
    img: 'zurich.svg',
    url: 'https://www.zurich.com.pt/pt-pt/a-zurich/sala-de-imprensa/comunicados-imprensa/2023/3-abr/',
  },
  {
    name: 'Top 10 global startups from Americas, Insurtech Insights, 2021',
    img: 'insurtech.png',
    url: 'https://www.insurtechinsights.com/future-50-americas/',
  },
];

export const mailFormat =
  /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

// Free/personal email domains that are not treated as a work email.
export const personalEmailDomains = [
  'gmail.com', 'googlemail.com', 'yahoo.com', 'yahoo.co.in', 'yahoo.co.uk',
  'hotmail.com', 'hotmail.co.uk', 'outlook.com', 'live.com', 'msn.com',
  'aol.com', 'icloud.com', 'me.com', 'mac.com', 'protonmail.com', 'proton.me',
  'gmx.com', 'gmx.net', 'mail.com', 'yandex.com', 'yandex.ru', 'zoho.com',
  'rediffmail.com', 'ymail.com', 'inbox.com', 'aim.com', 'comcast.net',
  'rocketmail.com', 'fastmail.com', 'hey.com', 'pm.me',
];

export const isWorkEmail = (email) => {
  if (!email) return false;
  const at = email.lastIndexOf('@');
  if (at === -1) return false;
  const domain = email.slice(at + 1).trim().toLowerCase();
  return domain.length > 0 && !personalEmailDomains.includes(domain);
};
